export enum ProjectionType {
  Global = 'Global',
  Manual = 'Manual',
  Local = 'Local',
}
